// extracted by mini-css-extract-plugin
export default {"imageContainer":"T0-z","summaryPar":"U0-z","ratingCategories":"V0-z","reviewerInfo":"W0-z","reviewTypes":"X0-z","expanded":"Y0-z"};